import { addIcons } from 'ionicons'
import {
  add,
  book,
  bookOutline,
  calendarOutline,
  cashOutline,
  checkmarkOutline,
  closeOutline,
  downloadOutline,
  eyeOffOutline,
  eyeOutline,
  listSharp,
  manOutline,
  peopleOutline,
  settingsOutline,
  swapVerticalSharp,
  walkOutline,
} from 'ionicons/icons'

export const registerIonicons = () => {
  addIcons({
    add,
    book,
    bookOutline,
    calendarOutline,
    cashOutline,
    checkmarkOutline,
    closeOutline,
    downloadOutline,
    eyeOffOutline,
    eyeOutline,
    listSharp,
    manOutline,
    peopleOutline,
    settingsOutline,
    swapVerticalSharp,
    walkOutline,
  })
}
